// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperInteractions-cls1_M2f","cls2":"PaperInteractions-cls2_uAT PaperInteractions-cls1_M2f"};